export const categories = [
  {
    _id: "1s469ers6",
    category: "affiliate marketing",
    slug: "affiliate-marketing",
    show: true,
  },
  {
    _id: "8d5s55fsd8",
    category: "cryptocurrency",
    slug: "mlm-plan",
    show: true,
  },
  {
    _id: "8d56s6fsd6",
    category: "free plan",
    slug: "free-plan",
    show: true,
  },
  {
    _id: "f7s8f8dsf",
    category: "freemlm",
    slug: "free-mlm",
    show: true,
  },
  {
    _id: "7fd8f8df",
    category: "refer & earn",
    slug: "reffer-earn",
    show: true,
  },
  {
    _id: "fd7fs8f8ds8f",
    category: "stock market",
    slug: "stock-market",
    show: true,
  },
];